// UsersQuickStats.tsx
import React from 'react';

import { GetFlagsResponse } from 'redux/reducers/moderation/types';
import { RestrictionAgg, UsersCounters } from '../types';
import './UsersQuickStats.scss';

type Props = {
  totalUsers: number;
  usersWithRestrictions: number;
  counters: UsersCounters | null; // ✅ тепер один і той самий тип
  topRestrictions: RestrictionAgg[];
  onPickRestriction?: (r: number) => void;
  flags: GetFlagsResponse | null;
};

export const UsersQuickStats: React.FC<Props> = ({
  totalUsers,
  usersWithRestrictions,
  flags,
  counters,
  topRestrictions,
  onPickRestriction,
}) => {
  const total = safeNum(totalUsers);
  const withR = safeNum(usersWithRestrictions);
  const pct = total > 0 ? Math.round((withR / total) * 100) : 0;

  const businessPrivate = safeNum(counters?.business_private);
  const businessPublic = safeNum(counters?.business_public);
  const personalPrivate = safeNum(counters?.personal_private);
  const personalPublic = safeNum(counters?.personal_public);

  return (
    <section className="uv-stats">
      <div className="uv-stats__grid">
        <StatCard label="Total users" value={total} />
        <StatCard label="With restrictions" value={withR} />
        <StatCard label="% with restrictions" value={`${pct}%`} />
        <StatCard label="Personal (pub/priv)" value={`${personalPublic} / ${personalPrivate}`} />
        <StatCard label="Business (pub/priv)" value={`${businessPublic} / ${businessPrivate}`} />
      </div>

      {/* {!!topRestrictions.length && (
        <div className="uv-stats__chips">
          {topRestrictions.map((r) => (
            <button
              key={r.restriction}
              className="uv-stats__chip"
              onClick={() => onPickRestriction?.(r.restriction)}
            >
              R{safeNum(r.restriction)} · {safeNum(r.cnt)}
            </button>
          ))}
        </div>
      )} */}
    </section>
  );
};

const StatCard: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
  <div className="uv-stats__card">
    <div className="uv-stats__label">{label}</div>
    <div className="uv-stats__value">{value}</div>
  </div>
);

function safeNum(v: unknown, fallback = 0): number {
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(n) ? n : fallback;
}
